import React from 'react';
import PropTypes from 'prop-types';
import glamorous, { GlamorousComponent } from 'glamorous';
import { chubStandards, ChubP } from '../../../styles/typography';
import { ChubTableWrapper } from '../../../styles/table';
import ServerMessages from '../../../components/ServerMessages';
import { ServerMessage } from '../../../models/server-message.model';

const Title: GlamorousComponent<any, any> = glamorous('h1', { displayName: 'Title' })(chubStandards, {
  size: '24px',
  textAlign: 'left',
  margin: '0 20px',
});

const CountMessage: GlamorousComponent<any, any> = glamorous(ChubP, { displayName: 'CountMessage' })({
  margin: '0 20px',
});

const AS2PageMessagesWrapper: GlamorousComponent<any, any> = glamorous(ChubTableWrapper, {
  displayName: 'AS2PageMessagesWrapper',
})({
  maxWidth: '1525px',
  maxHeight: '600px',
  margin: '20px auto 0 auto',
  overflowX: 'hidden',
});

const AS2PageMessages = ({
  error,
  serverMessages,
  numberOfTransfers,
}: {
  error: any;
  serverMessages: ServerMessage[];
  numberOfTransfers: string;
}) => (
  <AS2PageMessagesWrapper>
    {error && (
      <>
        <Title>Error Fetching AS2 Transfer Results</Title>
      </>
    )}
    {!error && (
      <>
        <Title>AS2 Results</Title>
        <CountMessage> The last {numberOfTransfers} recorded transfers</CountMessage>
        <ServerMessages {...{ serverMessages }} />
      </>
    )}
  </AS2PageMessagesWrapper>
);

AS2PageMessages.displayName = 'AS2PageMessages';
AS2PageMessages.propTypes = {
  error: PropTypes.string,
  serverMessages: PropTypes.array,
  numberOfTransfers: PropTypes.string,
};

export default AS2PageMessages;
